import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo } from 'react';
import theme from '../../styles/theme';
import { Badge } from '../Badge';
const variations = {
    fewLeft: {
        backgroundColor: theme.colors.notice600,
        text: 'Just a few left',
    },
    new: {
        backgroundColor: theme.colors.positive600,
        text: 'New',
    },
    outOfStock: {
        backgroundColor: theme.colors.informative600,
        text: 'Out of stock',
    },
    sold: {
        backgroundColor: theme.colors.informative600,
        text: 'Sold',
    },
};
const ImageBadge = ({ modifier, }) => {
    const imageBadgeStyles = useMemo(() => (css `
        background-color: ${variations[modifier].backgroundColor};
        color: ${theme.colors.gray100};
      `), [
        modifier,
    ]);
    return (_jsx("div", { children: _jsx(Badge, Object.assign({ css: imageBadgeStyles, size: "extraSmall", type: "custom" }, { children: variations[modifier].text })) }));
};
export { ImageBadge };
